import axios from 'axios'

export const AdminLocationEntityImportService = {
  /**
   * @param {*} status blank is for both status(published and inactive)
   * status = 1 ==> for inactive
   * status = 2 ==> for published
   */
  addEntityData (data) {
    return axios.post(`/api/v1/importlocation`, data, { headers: {
      'Content-Type': 'multipart/form-data'
    }
    }
    )
  }
}
